<template>
  <div class="dwg_preview" id="drag_preview">
    <div class="rust-header h" slot="header">
      <span>{{fileNameTitle || '图纸预览'}}@{{svgCurrentScale.scale? svgCurrentScale.scale+'%':''}}</span>
    </div>
    <div class="svg-cont">
      <div class="svg-list">
        <ul>
          <li v-for="(i, index) in docList" :class="currentIndex === index? 'active' : ''" :key="index" @click="selectDwg(i, index)">
            {{i.name}}
          </li>
        </ul>
      </div>
      <div class="svg-wrapper" id="svg_wrapper">
        <div class="svg_content" id="svg_touch">
          <VueDragResize ref="dragable" :resizable="false" :sticks="false" @dragstop="onDragstop" @dragging="onDrag">
      　　　　<div class="svg_p"
                  id="dragDiv"
                  v-html="svgData">
            </div>
          </VueDragResize>
        </div>
        <div class="foot_btn">
          <i class="iconfont icon-enlarge"
              :style="svgCurrentScale.scale == 1400 ? 'color:#93ABCC': ''"
              @click="scaleSvg(true)"></i>
          <span @click="reset()">{{'1 : ' + (svgCurrentScale.scale? svgCurrentScale.scale/100:'')}}</span>
          <i class="iconfont icon-narrow"
          :style="svgCurrentScale.scale == 100 ? 'color:#93ABCC': ''"
              @click="scaleSvg(false)"></i>
        </div>
      </div>
    </div>
    <div id="middle">
      <i class="el-icon-more"></i>
    </div>
  </div>
</template>

<script>
// import $solway_d from '@/libs/utils/drag.js'
import $solway_z from '@/libs/utils/zoom.js'
import ApiService from '@/services/API-services'
import VueDragResize from 'vue-draggable-resizable'
export default {
  components: {
    VueDragResize
  },
  name: 'dwglist',
  props: ['modalInfo'],
  data() {
    return {
      svgData: '',
      currentData: null,
      scale: .3,
      maxScale: 14,
      fileNameTitle: null,
      svgZoom: null,
      svgCurrentScale: {},
      scaleCenterID: '',
      currentColor: true,
      selArr: [],
      docList: [],
      currentIndex: 0,
      remeberEleId: ''
    }
  },
  created() {
    this.$store.commit('closeModal', 'crafts')
    this.getDwgList()
    window.svgFUNC = {
      cTDG: this.openMap,
      mTDG: this.showtag,
      lTDG: this.hidetag
    }
    window.SVGDATA = { scale: 100 }
    this.svgCurrentScale = window.SVGDATA
  },
  destroyed() {
    document.getElementById('viewer').style.width = '100%'
    document.getElementById('viewer').style.left = '0'
    window.onWindowResize()
  },
  updated: function() {
    this.$nextTick(function() {
      if (!this.svgZoom && this.svgData) {
        const zoom = $solway_z.zoom({
          ele: document.getElementById('zoomSvg'),
          scale: 1,
          minScale: 1,
          maxScale: this.maxScale,
          scaleCenter: ''
        })
        this.svgZoom = zoom
        // document.getElementById(this.scaleCenterID).style.stroke = 'red;'
        zoom.scale(0)
      }
    })
  },
  mounted() {
    this.dragControllerDiv()
  },
  methods: {
    
    getBitById(val) {
      ApiService.doc.getBitById({
        glid: '',
        bitNumber: val,
        mileageID: window.R_config.modelId,
        cid: window.CID
      }).then(res => {
        if (res.code === 0) {
          if (!document.getElementById(res.data[0].gId)) return
          this.openMap(res.data[0].BitNumber, res.data[0].gId)
        }
      })
    },
    onDragstop() {
      document.getElementById('zoomSvg').style.top = '1'
    },
    onDrag() {
      document.getElementById('zoomSvg').style.top = '1'
    },
    getSvgPid() {
      ApiService.views.getSvgPid({
        bitNumber: window.Muster
      }).then(res => {
        if (res.code === 0) {
          this.docList.map((n, index) => {
            if (n.id === res.data[0].editionCadId) {
              this.selectDwg(n, index)
            }
          })
        } else {
          this.$message({
            message: '未找到对应模组',
            type: 'warn'
          })
        }
      })
    },
    getDwgList() {
      ApiService.draw.GetCadDataList({
        mileageID: window.R_config.modelId,
        bitNumber: '',
        linit: this.linit,
        page: this.currentDocPage
      })
      .then(res => {
        this.docList = res.data
        this.totalCount = res.count
        this.selectDwg(res.data[0], 0)
        // if (this.modalInfo.EditionCadId) {
        //   window.CID = this.modalInfo.EditionCadId
        // } else if (this.modalInfo.ID) {
        //   window.CID = this.modalInfo.ID
        // }
        // let that = this
        // this.docList.map((n,index) => {
        //   if (n.ID === that.modalInfo.ID) {
        //     that.currentIndex = index
        //   }
        // })
      })
    },
    selectDwg(i, index) {
      // if (this.remeberEleId) this.setEleColor(this.remeberEleId, '#000', 'click', '', '', true)
      this.selArr = []
      this.currentIndex = index
      this.fileNameTitle = i.name
      window.CID = String(i.id)
      this.readXML(i.pathUrl)
    },
    reset() {
      this.$refs.dragable.top = 0
      this.$refs.dragable.left = 0
      // document.getElementById('dragDiv').style.left = '0'
      // document.getElementById('dragDiv').style.top = '0'
      this.svgZoom.scale((100 - this.svgCurrentScale.scale) / 100)
    },
    setEleColor(val, color, event, bg, strokeWidth, flag) {
      document.getElementById('zoomSvg').style.top = '0'
      let b = document.getElementById(val)
      if (!b) {
        this.$message({
          message: '当前图纸不存在此构件！',
          type: 'warn'
        })
        return
      }
      let a = ''
      let e = ''
      if (b.getElementsByTagName('path')) {
        a = b.getElementsByTagName('path')
        e = b.getElementsByTagName('text')
      }
      let c = b.querySelector('ellipse')
      let d = b.querySelector('rect')
      if ((event == 'mouseEnter' || event == 'mouseLeave') && b.getAttribute('click')) return
      if (flag) b.style.fill = bg
      if (a.length > 0) {
        for(let i = 0; i < a.length; i++) {
          a[i].style.stroke = color
          a[i].style.strokeWidth = strokeWidth
          if (flag) a[i].style.fill = bg
        }
      }
      if (d) {
        d.style.fill = bg
        d.style.stroke = color
        d.style.strokeWidth = strokeWidth? '1.5px' : ''
      }
      if (c) {
        c.style.fill = bg
        c.style.stroke = color
        c.style.strokeWidth = strokeWidth? '1.5px' : ''
      }
      if (e) {
        for(let i = 0; i < e.length; i++) {
          e[i].style.fill = color
        }
      }
    },
    openMap(glid, eleID) {
      if (this.selArr.length > 0) {
        this.selArr.forEach(element => {
          this.setEleColor(element, '#000', 'click', '', '', true)
          document.getElementById(element).removeAttribute('click')
        })
        this.selArr = []
      }
      if (!glid && !eleID && !(eleID instanceof Array)) {
        this.getSvgPid()
        // this.setEleColor(this.remeberEleId, '#000', 'click', '', '', true)
        // document.getElementById(this.remeberEleId).removeAttribute('click')

        // this.$message({
        //   message: '未找到对应模组',
        //   type: 'warn'
        // })
        return false
      }
      if (eleID instanceof Array) {
        eleID.forEach(n => {
          let flag = n.gId.includes('group')
          let b = document.getElementById(n.gId)
          if (!b) return
          this.setEleColor(n.gId, '#f00', 'click', 'yellow', '3px', flag)
          if (flag) b.style.fill = 'yellow'
          let c = b.querySelector('ellipse')
          let d = b.querySelector('rect')
          if (c) {
            c.style.fill = 'yellow'
          } else if (d) {
            d.style.fill = 'yellow'
          }
          document.getElementById(n.gId).setAttribute('click', true)
          this.selArr.push(n.gId)
        })
      } else {
        let flag = eleID.includes('group')
        this.remeberEleId = eleID
        this.svgZoom.scaleCenterID = eleID
        if (this.selArr.length > 0) {
          this.selArr.forEach(element => {
            if (element != eleID) {
              this.setEleColor(element, '#000', 'click', '', '', true)
              document.getElementById(element).removeAttribute('click')
            }
          })
          this.selArr.shift()
        }
        let b = document.getElementById(eleID)
        if (!b) return
        this.setEleColor(eleID, '#f00', 'click', 'yellow', '3px', flag)
        if (flag) b.style.fill = 'yellow'
        let c = b.querySelector('ellipse')
        let d = b.querySelector('rect')
        if (c) {
          c.style.fill = 'yellow'
        } else if (d) {
          d.style.fill = 'yellow'
        }
        document.getElementById(eleID).setAttribute('click', true)
        this.selArr.push(eleID)
        this.zoomToEle(glid)
      }
    },
    // 构建着色
    zoomToEle(val) {
      window.ResetAllElement()
      ApiService.doc.getModelData({
        glid: '',
        BitNumber: val,
        mileageID: window.R_config.modelId
      }).then(res => {
        if (res.code !== 0) {
          this.$message({
            message: '未找到对应构件',
            type: 'warn'
          })
          window.ResetAllElement()
          window.resetView()
          return
        }
        let glids = ''
        if (res.data.glid.length > 1) {
          glids = res.data.glid.join('#')
        } else {
          glids = res.data.glid[0]
        }
        window.currentElement = glids
        window.elementType = 0
        if (res.data.angelCode) {
          window.StartViewAnimation([window.GetView(), res.data.angelCode], 5000)
        } else {
          window.FlyTo(glids, true, 2.8);
        }
        window.SetElementColor(glids, 255, 0, 0)
        this.getproperty(val)
      })
    },
    getproperty(bit) {
      window.Muster = bit
      ApiService.tree
        .property({
          mileageID: window.R_config.modelId,
          BitNumber: bit
        })
        .then(res => {
          if (res.code == 0) {
            let attrData = res.data
            this.$store.commit('syncAttrData', attrData)
          }
        })
    },
    showtag(glid, eleID) {
      this.setEleColor(eleID, '#f00', 'mouseEnter', 'yellow', '3px', eleID.includes('group'))
    },
    hidetag(glid, eleID) {
      this.setEleColor(eleID, '#000', 'mouseLeave', '', '', eleID.includes('group'))
    },
    scaleSvg(n) {
      if (this.svgZoom) {
        this.svgZoom.scale(n ? this.scale : -this.scale)
      }
    },
    readXML(url) {
      $.ajax(url).then(res => {
        this.svgData = res.getElementsByTagName('svg')[0].outerHTML
        if (window.CID) this.getBitById(window.Muster)
        setTimeout(() => {
          this.svgZoom = $solway_z.zoom({
            ele: document.getElementById('zoomSvg'),
            scale: 1,
            minScale: 1,
            maxScale: this.maxScale,
            scaleCenter: ''
          })
        }, 10)
      })
    },
    dragControllerDiv() {
      let resize = document.getElementById('middle')
      let dwg = document.getElementById('drag_preview')
      // let modelE = document.getElementById('viewer')
      let wrapper = document.getElementById('svg_wrapper')
      let box = document.body
      // modelE.style.width = (box.offsetWidth - dwg.offsetWidth) + 'px'
      // modelE.style.left = dwg.offsetWidth + 'px'
      window.onWindowResize()
      resize.onmousedown = function (e) {
        let startX = e.clientX;
        resize.left = resize.offsetLeft
        document.onmousemove = function (e) {
          let endX = e.clientX
          let moveLen = resize.left + (endX - startX)
          let maxT = box.clientWidth - resize.offsetWidth
          if (moveLen < 850) moveLen = 850
          if (moveLen > maxT - 850) moveLen = maxT - 850
          resize.style.left = moveLen
          dwg.style.width = moveLen + 'px'
          wrapper.style.width = moveLen + 'px'
          // modelE.style.width = (box.clientWidth - moveLen - 5) + 'px'
          // modelE.style.left = moveLen + 'px'
          window.onWindowResize()
        }
        document.onmouseup = function (evt) {
          document.onmousemove = null
          document.onmouseup = null
          resize.releaseCapture && resize.releaseCapture()
        }
        resize.setCapture && resize.setCapture()
        return false
      }
    }
  }
}
</script>

<style scoped lang='scss'>
@import '../../common/css/color.scss';
.dwg_preview {
  width: 1025px;
  height: calc(100vh - 40px);
}
.rust-header {
  line-height: 40px;
  text-align: left;
  color: $font_color;
  background: $card_header;
  padding: 0 20px;
}
.legend {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  .legend-icon {
    width: 15px;
    height: 10px;
    display: inline-block;
  }
}
.svg-cont {
  height: calc(100% - 40px);
  background: transparent;
  display: flex;
  .svg-list {
    background: rgba(2, 16, 33, 0.6);
    width: 175px;
    height: 100%;
    ul {
      li {
        color: rgba(255, 255, 255, 0.65);
        cursor: pointer;
        font-size: 13px;
        text-align: left;
        padding: 5px 10px;
        &:hover {
          background: rgba(243, 178, 49, 1);
          color: $font_color;
        }
      }
      .active {
        background: rgba(243, 178, 49, 1);
        color: $font_color;
      }
    }
  }
}
.svg-wrapper {
  height: 100%;
  width: 850px;
  display: flex;
  align-items: center;
  background: #fff;
  position: relative;
}
.svg_content {
  width: 100%;
  height: 650px;
  background-color: #fff;
  // margin: 15% auto;
  box-sizing: border-box;
  border: 1px solid #f1f1f1;
  position: relative;
  overflow: hidden;
  .circle-test {
    display: block;
    position: absolute;
    height: 10px;
    width: 10px;
    background: green;
    top: 50%;
    left: 50%;
    border-radius: 50%;
  }
  .draggable {
    width: 100% !important;
    height: 650px !important;
  }
  #dragDiv {
    background-color: #fff;
    width: 100%;
    box-sizing: border-box;
  }
}
.foot_btn {
  background: #323a45;
  width: 140px;
  height: 32px;
  display: flex;
  align-items: center;
  margin: 10px auto;
  color: #fff;
  justify-content: space-around;
  box-shadow: 0 1px 9px rgba(0, 0, 0, 0.3);
  border-radius: 4px;
  position: absolute;
  bottom: 30px;
  right: 0;
  left: 0;
  span {
    text-decoration: underline;
    cursor: pointer;
  }
  i {
    font-size: 20px;
    cursor: pointer;
  }
  .disable {
    color: #93ABCC;
  }
}
#middle {
  width: 5px;
  background: rgba(2, 16, 33, .5);
  height: calc(100vh - 40px);
  position: absolute;
  right: -5px;
  bottom: 0;
  cursor: col-resize;
  i {
    transform: rotate(90deg);
    position: absolute;
    bottom: 50%;
    left: -5px;
    color: #eee;
  }
  // button {
  //   cursor: col-resize;
  //   position: fixed;
  //   top: 50%;
  //   color: #9999;
  // }
}
</style>


// WEBPACK FOOTER //
// src/components/doc/dwgpreview.vue